module.exports = __webpack_public_path__ + "img/downloadThePrint.5381d045.jpg";